import { render, staticRenderFns } from "./invioceInfo.vue?vue&type=template&id=56bfa8e2&scoped=true"
import script from "./invioceInfo.vue?vue&type=script&lang=js"
export * from "./invioceInfo.vue?vue&type=script&lang=js"
import style0 from "./invioceInfo.vue?vue&type=style&index=0&id=56bfa8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bfa8e2",
  null
  
)

export default component.exports